import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import type { Student, Vehicle } from '../types';

interface SortableStudentProps {
  student: Student;
  vehicle: Vehicle;
  type: 'pickup' | 'dropoff';
  onDelete?: () => void;
}

const SortableStudent: React.FC<SortableStudentProps> = ({ student, vehicle, type, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: student.id,
    data: { 
      student,
      isScheduled: true
    }
  });

  // ... 나머지 코드는 그대로 유지
};

export default SortableStudent; 